var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_713",
    "data-name": "\\uC0AC\\uAC01\\uD615 713",
    width: 25.137,
    height: 23.16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uAD50\\uD1B5\\uC0AC\\uACE0\\uC704\\uD5D8\\uB3C4",
    transform: "translate(0 -145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_714",
    "data-name": "\\uC0AC\\uAC01\\uD615 714",
    width: 53,
    height: 53,
    transform: "translate(0 145)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD50\\uD1B5\\uC0AC\\uACE0\\uC704\\uD5D8\\uB3C4-2",
    "data-name": "\\uAD50\\uD1B5\\uC0AC\\uACE0\\uC704\\uD5D8\\uB3C4",
    transform: "translate(6 153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2158",
    "data-name": "\\uADF8\\uB8F9 2158",
    transform: "translate(8 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3611",
    "data-name": "\\uD328\\uC2A4 3611",
    d: "M13.712,5.068a2.194,2.194,0,1,0-2.194-2.193,2.193,2.193,0,0,0,2.194,2.193",
    transform: "translate(0.616 0.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3612",
    "data-name": "\\uD328\\uC2A4 3612",
    d: "M19.368,11.4,18.72,7.818a1.3,1.3,0,0,0-1-1.039l-3.71-.8L12.051,4.328a1.536,1.536,0,0,0-.292-.19L7.039.292A1.3,1.3,0,1,0,5.4,2.3l3.8,3.1L6.664,8.394l-2.931.047a1.46,1.46,0,0,0-1.217.687L.222,12.8A1.461,1.461,0,1,0,2.7,14.352l1.874-3,2.457-.039-1.777,1.1a1.464,1.464,0,0,0-.679,1.043l-.642,4.636a1.461,1.461,0,0,0,1.247,1.648,1.631,1.631,0,0,0,.2.014,1.462,1.462,0,0,0,1.445-1.261l.547-3.955L10.46,12.62l-.1.059a1.477,1.477,0,0,0,.43-.346l1.162-1.376L13.928,8.62l2.39.515.493,2.728a1.3,1.3,0,0,0,1.277,1.068,1.248,1.248,0,0,0,.232-.021A1.3,1.3,0,0,0,19.368,11.4M9.511,12.853h0m-.468-.13c.026.013.054.024.081.035-.027-.011-.054-.022-.081-.035m.874.107c.017,0,.034-.005.051-.009-.017,0-.034.006-.051.009",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3613",
    "data-name": "\\uD328\\uC2A4 3613",
    d: "M22.759,16.84H11.439a.934.934,0,0,1-.933-.933l.839-4.755a.912.912,0,0,1,.927-.859h9.655a.934.934,0,0,1,.932.89l.827,4.649a.944.944,0,0,1-.927,1.008m-11.4-.87a.507.507,0,0,0,.077.019H22.759a.083.083,0,0,0,.083-.082l-.833-4.681a.083.083,0,0,0-.082-.083H12.272a.083.083,0,0,0-.082.083l-.84,4.755c0-.008.006-.012.013-.012",
    transform: "translate(0.562 0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3614",
    "data-name": "\\uD328\\uC2A4 3614",
    d: "M24.182,14.948l-.732-.788a.213.213,0,0,0-.156-.067H10.958a.213.213,0,0,0-.156.067l-.732.788a.209.209,0,0,0-.057.144v5.123a.213.213,0,0,0,.213.213h13.8a.213.213,0,0,0,.213-.213V15.093a.209.209,0,0,0-.057-.144M12.526,19A1.193,1.193,0,1,1,13.719,17.8,1.193,1.193,0,0,1,12.526,19m9.2,0A1.193,1.193,0,1,1,22.919,17.8,1.193,1.193,0,0,1,21.726,19",
    transform: "translate(0.535 0.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3615",
    "data-name": "\\uD328\\uC2A4 3615",
    d: "M11.588,22.159H10.95a.937.937,0,0,1-.938-.937V19.686a.937.937,0,0,1,.938-.937h.638a.937.937,0,0,1,.937.937v1.537a.937.937,0,0,1-.937.937",
    transform: "translate(0.535 1.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3616",
    "data-name": "\\uD328\\uC2A4 3616",
    d: "M22.707,22.159h-.638a.937.937,0,0,1-.938-.937V19.686a.937.937,0,0,1,.938-.937h.638a.937.937,0,0,1,.937.937v1.537a.937.937,0,0,1-.937.937",
    transform: "translate(1.13 1.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3617",
    "data-name": "\\uD328\\uC2A4 3617",
    d: "M11.35,14.333s-1.165-.971-1.554-.846.153,1.415,1,1.221Z",
    transform: "translate(0.517 0.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3618",
    "data-name": "\\uD328\\uC2A4 3618",
    d: "M22.264,14.333s1.165-.971,1.554-.846-.153,1.415-1,1.221Z",
    transform: "translate(1.19 0.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3619",
    "data-name": "\\uD328\\uC2A4 3619",
    d: "M15.922,15.988l-.263-2.845a.334.334,0,0,0-.333-.3H13.064a.334.334,0,0,0-.333.3l-.263,2.845H13.98V14.413h.431v1.575Z",
    transform: "translate(0.667 0.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3620",
    "data-name": "\\uD328\\uC2A4 3620",
    d: "M21.236,15.988l-.263-2.845a.334.334,0,0,0-.333-.3H18.378a.334.334,0,0,0-.333.3l-.263,2.845h1.512V14.413h.431v1.575Z",
    transform: "translate(0.951 0.686)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.5c1b5892845ec60a58dbe35fa60377b1.svg";
export { ForwardRef as ReactComponent };